

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import VTable from '../../shared/table/VTable.vue';
import VColumnSelect from '@/components/shared/table/VColumnSelect.vue';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import optionHeaders from './headers';
import { OptionArticle } from '@/interfaces/models/OptionArticle';
import { Permission } from '@/enums/Permission';

@Component({
  components: { VColumnSelect, VTable },
})
export default class OptionArticleTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: OptionArticle[];
  @Prop({ type: String, default: '6' }) public offset!: number;

  public sourceHeaders = optionHeaders;
  public headers: ColumnHeader[] = [];

  get sorted() {
    return this.items.sort((a: OptionArticle, b: OptionArticle) => a.sortOrder - b.sortOrder);
  }

  public canToggleVisbility(val: boolean) {
    if (val) {
      return this.$can(Permission.OPTION_ARTICLE_VISIBLE);
    }
    return this.$can(Permission.OPTION_ARTICLE_HIDE);
  }
}
